// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"posts-module--wrapper--1uttP","headline":"posts-module--headline--2WL9Y","cards":"posts-module--cards--1thHq","card":"posts-module--card--1VuAC"};